import robot_01 from './robot_01.jpg';
import robot_02 from './robot_02.jpg';
import robot_03 from './robot_03.jpg';
import robot_04 from './robot_04.jpg';
import robot_05 from './robot_05.jpg';

export const AVATARS = { robot_01, robot_02, robot_03, robot_04, robot_05 };

export const AVATAR_GROUPS: Record<string, Array<Avatar>> = {
  robots: ['robot_01', 'robot_02', 'robot_03', 'robot_04', 'robot_05'],
};

export type Avatar = keyof typeof AVATARS;
